import { render, staticRenderFns } from "./DeleteResident.vue?vue&type=template&id=42411751&scoped=true&"
import script from "./DeleteResident.vue?vue&type=script&lang=js&"
export * from "./DeleteResident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42411751",
  null
  
)

export default component.exports